import { render } from "./YoubeSingleItem.vue?vue&type=template&id=c234d9d0&scoped=true"
import script from "./YoubeSingleItem.vue?vue&type=script&lang=js"
export * from "./YoubeSingleItem.vue?vue&type=script&lang=js"

import "./YoubeSingleItem.vue?vue&type=style&index=0&id=c234d9d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c234d9d0"]])

export default __exports__